


















import { Component, Mixins } from 'vue-property-decorator';
import { Mutations, Views, ViewModes, Buttons } from '@/ts/store/Constants';
import DeviceMethods from '@/mixins/DeviceMethods.vue';
import ProfileImage from '@/components/User/ProfileImage.vue';
import UserInfo from '@/components/User/UserInfo.vue';
import AdminUserInfo from '@/components/User/AdminUserInfo.vue';
import AdminUserInfoBox from '@/components/User/AdminUserInfoBox.vue';
import MobileUserInfo from '@/components/User/MobileUserInfo.vue';
import MobileUserEditInfo from '@/components/User/MobileUserEditInfo.vue';

@Component({
    components: {
        UserInfo,
        ProfileImage,
        AdminUserInfo,
        AdminUserInfoBox,
        MobileUserInfo,
        MobileUserEditInfo,
    },
})
export default class PublicProfile extends Mixins(DeviceMethods) {
    constructor() {
        super();

        this.$store.commit(Mutations.SET_LEFT_HEADER_BUTTON, Buttons.None);
        this.$store.commit(Mutations.SET_BOTTOM_MENU_VISIBILITY, true);
    }

    public created() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Profile,
            viewMode: ViewModes.Profile.Profile,
        });
    }

    get view() {
        return this.$store.getters['Viewport/getCurrentView'];
    }

    get profileView() {
        return (this.view.viewMode === ViewModes.Profile.Profile);
    }

    get editProfile() {
        return (this.view.viewMode === ViewModes.Profile.EditProfile);
    }
}
